<template>
  <div>
    <div id="content">
      <b-img
          center
          :src="logoImg"
          id="logo"
      ></b-img>
      <b-form
          @submit="onSubmit"
          id="form">
        <b-form-group
            id="phoneInputGroup"
            label-for="phoneInput">
          <b-form-input
              id="phoneInput"
              v-model="form.phone"
              type="text"
              required
              placeholder="Enter phone"
          ></b-form-input>
        </b-form-group>
        <b-form-group
            id="passwordInputGroup"
            label-for="passwordInput">
          <b-form-input
              id="passwordInput"
              v-model="form.password"
              type="password"
              required
              placeholder="Enter password"
          ></b-form-input>
        </b-form-group>
        <b-button
            type="submit"
            variant="primary"
            id="button">
          登录
        </b-button>
      </b-form>
      <b-alert
          v-model="fail"
          variant="danger"
          dismissible
          class="alert">
        登录失败
      </b-alert>
      <a href="#/signup" class="hint">
        没有账号？前往注册
      </a>
    </div>
  </div>
</template>

<script>
import common from "../common";

export default {
  name: "Login",
  data() {
    return {
      fail: false,
      logoImg: common.logoImgSrc,
      form: {
        phone: '',
        password: '',
      },
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.axios.post(common.apiBase + common.apiService.login, {
        'token': 'login',
        'data': {
          'phone': this.form.phone,
          'password': this.form.password,
        }
      }).then((res) => {
        localStorage.setItem('loginToken', res.data.data.token);
        localStorage.setItem('loginName', res.data.data.name);
        this.$router.push('/personal');
      }).catch((err) => {
        this.fail = true;
        console.log(err);
      });
    },
  }
}
</script>

<style scoped>
#content {
  width: 40vw;
  box-shadow: lightgray 2px 2px 10px 1px;
  padding: 5vw;
  border-radius: 3vw;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#logo {
  width: 30%;
}

#form {
  width: 100%;
  max-width: 600px;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 5vh;
}

#phoneInput, #passwordInput{
  border: lightgray solid;
  border-radius: 0;
  border-width: 0 0 1px 0;
  background-color: transparent;
  outline: none;
}

#button {
  width: 90%;
  height: 10%;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 1vh;
  border-radius: 4vh;
  border: none;
  background: lightseagreen;
}

.alert {
  width: 50%;
  max-width: 600px;
  margin-left: 50%;
  margin-top: 2vh;
  transform: translateX(-50%);
}

.hint {
  display: block;
  margin-top: 20px;
  margin-left: 50%;
  transform: translateX(-50%);
  color: grey;
}
</style>